import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  LocalGroceryStore,
  StorageRounded,
  Menu,
  Cancel,
  ExitToAppRounded,
  Groups2Rounded
} from "@mui/icons-material";
import { useSidebarStyles } from "../../styles/sidebar";
import { ScreenControl } from "../app/ScreenControl";
import { useCookies } from "react-cookie";
import { Text } from "../FormControls/Text";
import { Stack } from "../FormControls/Stack";
import { COLORS } from "../../styles/defaults";

export const FloatingButton = ({ path }) => {
  const classes = useSidebarStyles(); // Aplicar los estilos
  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const [cookies, setCookies, removeCookie] = useCookies(["source"]);
  const storeInfo = useSelector(({ store }) => store);

  // ALERT OPTIONS
  const handleCloseAlert = () => {
    setCookies("exit", true)
    toggleMenu()
    return false;
  };

  const handleSelect = (value) => {
    setCookies("source", path);
    return true;
  };

  // Función para cerrar y abrir el menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Posicionamineto de las opciones del menu en grados
  const options = [
    {//CLOSE BUTTOM
      component:(
        <Stack
          flex={{ flexDirection: "row"}}
          style={{
            display: "flex",
            alignItems: "right",
            justifyContent: "right",
            color: COLORS.primary.acept,
          }}
        >
          <Cancel style={{
            paddingRight: "5",
            fontSize: 25
          }}/>
        </Stack>
      ),
      onClick: () => toggleMenu(),
    },
    {//TEXTO STORE
      component: (
        <ScreenControl
          index={{ fw: 8 }}
          disabled={false}
          parentClasses={["cardOptionMenu"]}
        > 
          <Stack flex={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
            <Stack flex={{ flexDirection: "column", alignItems: "center", gap: 5 }}>
              <Text  
                classes={["mediumText"]}
                style={{
                  color: COLORS.primary.light,
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "right",
                  fontSize: 10
                }}
              >{``}Comercio #: {`${storeInfo.pos.value}`}</Text>
              <Text  
                classes={["mediumText"]}
                style={{
                  color: COLORS.primary.light,
                  display: "flex",
                  alignItems: "right",
                  justifyContent: "right",  
                  fontSize: 10
                }}
              >{``}Nombre: {`${storeInfo.storeName.value}`}</Text>
            </Stack>
            <LocalGroceryStore style={{
              color: COLORS.primary.light,
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
              fontSize: 35
            }}></LocalGroceryStore>
          </Stack>
        </ScreenControl>
      ),
      onClick: () => {},
    },
    {//TRANSACTIONS BUTTOM
      component: (
        <ScreenControl
          index={{ fw: 11 }}
          disabled={false}
          parentClasses={["cardOptionMenu"]}
        >
          <Stack flex={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
            <StorageRounded style={{
                color: COLORS.primary.font,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 35
              }}></StorageRounded>
            <Text  
              classes={["mediumText"]}
              style={{
                color: COLORS.primary.font,
                display: "flex",
              }}
            >Transacciones</Text>
          </Stack>
        </ScreenControl>
      ),
      onClick: () => {
        setCookies("detalleTrx", true)  
        handleSelect()
      },
    },
    storeInfo.masterUser.value == true && (
    {// OPTIONS IF USER IS MASTER
      component: (
        <ScreenControl
          index={{ fw: 15 }}
          disabled={false}
          parentClasses={["cardOptionMenu"]}
        >
          <Stack flex={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
            <Groups2Rounded style={{
                color: COLORS.primary.font,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 35
              }}></Groups2Rounded>
            <Text  
              classes={["mediumText"]}
              style={{
                color: COLORS.primary.font,
                display: "flex",
              }}
            >Usuarios</Text>
          </Stack>
        </ScreenControl>
      ),
      onClick: () => {}
    }),
    {//EXIT BUTTOM
      component: (
        <ScreenControl
          index={null}
          beforeSubmit={() => handleCloseAlert()} 
          disabled={false}
          parentClasses={["cardOptionMenu"]}
        >
          <Stack flex={{ flexDirection: "row", alignItems: "center", gap: 15 }}>
            <ExitToAppRounded style={{
                color: COLORS.primary.font,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 35
              }}></ExitToAppRounded>
            <Text  
              classes={["mediumText"]}
              style={{
                color: COLORS.primary.font,
                display: "flex",
              }}
            >Salir</Text>
          </Stack>
        </ScreenControl>
      ),
      onClick: () => {}
    },
  ];

  return (
    <div className={classes.buttonContainer}>

      {/* Botun principal */}
      <button 
        style={{
          position: "fixed",
          top: "1rem",
          right: "0.2rem"
        }} 
        className={classes.rotatingButton} 
        onClick={toggleMenu}
      >
          <Menu />
      </button>

      {/* Menú desplegable */}
      {isMenuOpen && (
        <div 
        className={classes.menuContainer}
        >
          {options.map((option, index) => (
            <div
              key={index}
              onClick={option.onClick}
            >
              {option.component}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default FloatingButton;
